import React from "react";

import { DataTableContext } from "commons/context/dataTable";

import { DataTableHook } from "commons/hooks/useDataTable";

import DataTableFooter from "commons/ui/datatable/DataTableFooter";
import TableBody from "commons/ui/datatable/TableBody";
import TableContainer from "commons/ui/datatable/TableContainer";
import TableHead from "commons/ui/datatable/TableHead";

export type DataTablePropsType<T> = {
    readonly dataTableHook: DataTableHook<T>;
    readonly extraButtons?: JSX.Element;
    readonly className?: string;
    readonly showExtraRowsWhenEmpty?: boolean;
    readonly extraRows?: JSX.Element;
    readonly dontShowExportXlsxButton?: boolean;
};

function DataTable<T>({
    dataTableHook,
    extraButtons,
    className,
    showExtraRowsWhenEmpty = false,
    extraRows,
    dontShowExportXlsxButton,
}: DataTablePropsType<T>) {
    const {
        loadTableData,
        onHeaderCellClick,
        setPage,
        exportXlsxListButton,
        apiError,
        columns,
        sort,
        rows,
        loading,
        totalElements,
        elements,
        page,
        size,
        hideTableHead,
        hideTableFooter,
    } = dataTableHook;

    const dataTableContextValue = React.useMemo(
        () => ({ loadTableData, elements, sort }),
        [loadTableData, elements, sort]
    );

    return (
        <DataTableContext.Provider value={dataTableContextValue}>
            <TableContainer>
                {apiError ? (
                    <h6
                        style={{
                            textAlign: "center",
                            fontSize: "1rem",
                            color: "rgba(249, 66, 58, 1)",
                            textTransform: "unset",
                            wordBreak: "break-all",
                        }}
                    >
                        {"C'è stato un errore nel caricare i dati della tabella"}
                        <br />
                        <br />
                        {"Identificativo errore per assistenza: " +
                            (apiError.request.headers as any)["X-Request-ID"]}
                        <br />
                        <br />
                        {apiError.request.method + " " + apiError.response.url.toString()}
                        <br />
                        {"Codice di stato: " + apiError.responseStatus}
                    </h6>
                ) : (
                    <table className={className}>
                        {!hideTableHead && (
                            <TableHead
                                columns={columns}
                                sort={sort}
                                onHeaderCellClick={onHeaderCellClick}
                            />
                        )}

                        <TableBody
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            showExtraRowsWhenEmpty={showExtraRowsWhenEmpty}
                            extraRows={extraRows}
                            hideTableHead={hideTableHead}
                        />

                        {!hideTableFooter && (
                            <DataTableFooter
                                rowsPerPage={size}
                                extraButtons={extraButtons}
                                setPage={setPage}
                                exportXlsxListButton={exportXlsxListButton}
                                dontShowExportXlsxButton={dontShowExportXlsxButton}
                                totalElements={totalElements}
                                page={page}
                                colSpan={columns.length}
                            />
                        )}
                    </table>
                )}
            </TableContainer>
        </DataTableContext.Provider>
    );
}

export default DataTable;
